import React from 'react';
import PropTypes from 'prop-types';
import { Alert } from 'antd';
import GlobalRules from './GlobalRules';
import BeerRules from './BeerRules';
import MixPacks from './MixPacks';
import TankBeer from './TankBeer';

const RulesTab = ({ plan, canEdit }) => (
  <div>
    {!canEdit && (
      <Alert
        className="forecasting-section"
        type="info"
        showIcon
        message="Read only: editing needs the forecasting.edit permission"
      />
    )}
    <GlobalRules canEdit={canEdit} />
    <BeerRules plan={plan} canEdit={canEdit} />
    <MixPacks plan={plan} canEdit={canEdit} />
    <TankBeer plan={plan} canEdit={canEdit} />
  </div>
);

RulesTab.propTypes = {
  plan: PropTypes.shape({}).isRequired,
  canEdit: PropTypes.bool.isRequired,
};

export default RulesTab;
